import {
  email as mail,
  helpers,
  required as require,
  sameAs,
} from '@vuelidate/validators';

export const account = helpers.withMessage(
  '帳號須包含英文字母、數字或符號',
  // eslint-disable-next-line no-control-regex
  helpers.regex(/^[\x00-\x1F|\x21-\x7F]+$/),
);

export const email = helpers.withMessage('電子郵件格式錯誤', mail);

export const identification = helpers.withMessage(
  '統一編號必須為8碼數字',
  helpers.regex(/^\d{8}$/),
);

export const mobile = helpers.withMessage(
  '手機號碼僅能輸入數字 + -',
  helpers.regex(/^[0-9+-]*$/),
);

export const password = helpers.withMessage(
  '密碼限8個字元以上，並且必須包含英文字母及數字',
  helpers.regex(/^(?=.{8,})(?=.*\d)(?=.*[a-z]+|[A-Z]+)(?=.*[@#_$%^&+=]?).*$/),
);

export const phone = helpers.withMessage(
  '分機/電話僅能輸入數字 + - # * ()',
  helpers.regex(/^[0-9+\-#*()]*$/),
);

export const required = (field) => helpers.withMessage(`${field}為必填`, require);
export const sameAsPassword = (pwd) => helpers.withMessage('您輸入的兩個密碼並不相符，請再試一次', sameAs(pwd()));

export default {
  email,
  mobile,
  password,
  phone,
  required,
  sameAsPassword,
};
